export const CITIES_START = 'communityCities/CITIES_START';
export const CITIES_SUCCESS = 'communityCities/CITIES_SUCCESS';
export const CITIES_ERROR = 'communityCities/CITIES_ERROR';
